const markers = [
	// people

	{
		"tth1": "Andy Wong",
		"tth2": "Associate",
		"ttsubheading": "",
		"ttcopy": "At an early stage, I started to think about which specific area I would like to practise in. To my mind, Intellectual Property is a particularly valuable – but often neglected – asset for businesses, so this was the area I decided to pursue.",
		"ttimg": "assets/img/map/andy-wong.jpg",
		"tturl": "/about/our-people/andy-wong/",
		"coordinates": [
			27,
			39
		],
		"category": "person",
		"mimg": "",
		"mh1": "",
		"mcontent": ""
	},

	{
		"tth1": "Weng Keong Kok",
		"tth2": "Associate",
		"ttsubheading": "",
		"ttcopy": "It was the Firm’s global footprint and reputation for cutting edge legal work that first attracted me to Baker McKenzie. That, and the cookies at the recruitment fair!",
		"ttimg": "assets/img/map/weng-keong-kok.jpg",
		"tturl": "/about/our-people/weng-keong-kok/",
		"coordinates": [
			79,
			59
		],
		"category": "person",
		"mimg": "",
		"mh1": "",
		"mcontent": ""
	},

	{
		"tth1": "Alison Tsang",
		"tth2": "Associate",
		"ttsubheading": "",
		"ttcopy": "I wanted a career that combined both technical and practical elements. One that was constantly evolving, and where I’d have the opportunity to keep on learning beyond my own area of expertise.",
		"ttimg": "assets/img/map/alison-tsang.jpg",
		"tturl": "/about/our-people/alison-tsang/",
		"coordinates": [
			47.8,
			31.5
		],
		"category": "person",
		"mimg": "",
		"mh1": "",
		"mcontent": ""
	},

	// deals

	{
		"tth1": "Spain",
		"tth2": "",
		"ttsubheading": "",
		"ttcopy": "We helped global healthcare giant, Johnson & Johnson, work towards a more sustainable future.",
		"ttimg": "assets/img/map/spain-tooltip.jpg",
		"tturl": "https://www.bakermckenzie.com/en/newsroom/2021/07/johnson-johnson-vppa",
		"coordinates": [
			48,
			38
		],
		"category": "deal",
		"mimg": "",
		"mh1": "the deal",
		"mcontent": "deal content"
	},
	{
		"tth1": "Colombia",
		"tth2": "",
		"ttsubheading": "",
		"ttcopy": "We negotiated Empresas Públicas de Medellín’s (EPM) acquisition of Electricaribe – the largest energy sector deal of the year.",
		"ttimg": "assets/img/map/colombia.jpg",
		"tturl": "https://www.bakermckenzie.com/en/newsroom/2020/05/epm-acquires-caribemar",
		"coordinates": [
			26,
			59
		],
		"category": "deal",
		"mimg": "",
		"mh1": "the deal",
		"mcontent": "deal content"
	},
	{
		"tth1": "Mexico",
		"tth2": "",
		"ttsubheading": "",
		"ttcopy": "We advised Enagás and Elecnor on the US$173.8 million sale of their Mexican subsidiaries in the Morelos gas pipeline.",
		"ttimg": "assets/img/map/mexico.jpg",
		"tturl": "https://www.bakermckenzie.com/en/newsroom/2021/12/enagas-and-elecnor-sale-of-morelos",
		"coordinates": [
			19,
			49
		],
		"category": "deal",
		"mimg": "",
		"mh1": "the deal",
		"mcontent": "deal content"
	},
	{
		"tth1": "Saudi Arabia",
		"tth2": "",
		"ttsubheading": "",
		"ttcopy": "We were key to Saudi Tadawul Group Holding’s US$1 billion IPO and US$3.4 billion listing on the Saudi Stock Exchange.",
		"ttimg": "assets/img/map/saudi-arabia.jpg",
		"tturl": "https://www.bakermckenzie.com/en/newsroom/2021/12/saudi-tadawul-group",
		"coordinates": [
			60,
			48
		],
		"category": "deal",
		"mimg": "",
		"mh1": "the deal",
		"mcontent": "deal content"
	},
	{
		"tth1": "Australia",
		"tth2": "",
		"ttsubheading": "",
		"ttcopy": "We helped Zenobē and Transgrid secure the necessary finance for Australia's largest fleet of electric buses.",
		"ttimg": "assets/img/map/australia.jpg",
		"tturl": "https://www.bakermckenzie.com/en/newsroom/2021/10/zenobe-transgrid-electric-bus-project",
		"coordinates": [
			87,
			78
		],
		"category": "deal",
		"mimg": "",
		"mh1": "the deal",
		"mcontent": "deal content"
	}
]


function ready(callback) {
	document.readyState === 'interactive'
		? callback()
		:  document.addEventListener('DOMContentLoaded', callback)
}

function setTooltip(marker) {

	const tooltip = {
		h1 : document.getElementById('tth1'),
		h2 : document.getElementById('tth2'),
		subheading : document.getElementById('ttsubheading'),
		copy : document.getElementById('ttcopy'),
		imgcontainer : document.getElementById('ttimgcontainer'),
		img : document.getElementById('ttimg'),
		link : document.getElementById('ttlink'),
	}

	tooltip.h1.innerHTML = marker.tth1
	tooltip.h2.innerHTML = marker.tth2
	tooltip.subheading.innerHTML = marker.ttsubheading
	tooltip.copy.innerHTML = marker.ttcopy

	if (marker.ttimg) {
		const src = window.stylesheetUri + '/' + marker.ttimg
		tooltip.img.src = src
		tooltip.img.style.display = 'block'
	} else {
		tooltip.img.style.display = 'none'
	}

	if (tooltip.link.href === '#modal') {
		tooltip.link.setAttribute('target', '')
		tooltip.link.classList.add('mmodal-toggle')
	} else {
		tooltip.link.href = marker.tturl
		tooltip.link.setAttribute('target', '_blank')
		tooltip.link.classList.remove('mmodal-toggle')
	}
}

function setupModal() {

	const modal = document.getElementById('mmodal')

	// delegate event for 'mmodal-toggle class' to allow tippy instance clicks
	document.addEventListener('click', e => {
		const isToggle = (
			e.target && 
			e.target.classList.contains('mmodal-toggle')
		)
		if (!isToggle) return
		e.preventDefault()
		modal.classList.toggle('is-visible')
	})

	window.addEventListener('keydown', event => {
		const escKey = (event.key === 'Escape' || event.keyCode === 27)	
		if (escKey) modal.classList.remove('is-visible')
	})
}

function setModal(marker) {
	const modal = {
		h1 : document.getElementById('mh1'),
		content : document.getElementById('mcontent'),
		imgcontainer : document.getElementById('mimgcontainer'),
		img : document.getElementById('mimg'),
	}

	modal.h1.innerHTML = marker.mh1
	modal.content.innerHTML = marker.mcontent

	if (marker.mimg) {
		modal.imgcontainer.style.display = 'block'
		modal.img.src = marker.mimg
	} else {
		modal.imgcontainer.style.display = 'none'
	}
}

function addMarkers(markers) {
	const container = document.getElementById('map-container')
	const ttEl = document.getElementById('tippy-tip')

	markers.map(marker => {
		const { coordinates, category } = marker

		const el = document.createElement('div')
		el.className = ('map-marker map-marker--' + category)
		el.style.left = coordinates[0] + "%"
		el.style.top = coordinates[1] + "%"
		container.appendChild(el)

		el.addEventListener('mouseover', () => {
			setTooltip(marker)
			setModal(marker)
		})
	})
}


ready(() => {
	addMarkers(markers)
	setupModal()

	tippy('.map-marker', {
		content: document.getElementById('tippy-tip').innerHTML,
		allowHTML: true,
		interactive: true,
		theme: "baker",
		arrow: false,
		interactiveBorder: 10,
		delay: [50, 0],
		onShow(instance) {
			// copy contents from latest popup el to new tippy instance
			instance.setProps({ 
				content: document.getElementById('tippy-tip').innerHTML, 
			}); 
		}
	})
})